import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ValidatorService } from '../../core/services/validator.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressSuggestionsService } from '../../core/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FlyoutOption } from 'dap-ui-library';
import { Address } from '../../pages/key-data/key-data.types';
import dayjs from 'dayjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-personal-address',
  templateUrl: './personal-address.component.html',
  styleUrls: ['./personal-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalAddressComponent implements OnInit {
  @Input() public formGroup: FormGroup;
  @Input() public validateForm: boolean = false;

  public showZipCodeComponent$: Observable<boolean>;
  public address = new FormControl<FlyoutOption<Address> | null>(null);
  public saleOfferBegin = new FormControl<string>(dayjs().format('YYYY-MM-DD'), {
    nonNullable: true,
    validators: Validators.required,
  });

  constructor(
    public validatorService: ValidatorService,
    private addressSuggestionsService: AddressSuggestionsService,
  ) {}

  public ngOnInit(): void {
    let currentBfsNumber = this.formGroup.get('bfsNumber')?.value;
    let zipCode = this.formGroup.get('zipCode')?.value;

    this.showZipCodeComponent$ = this.addressSuggestionsService
      .autocomplete(zipCode, dayjs().format('YYYY-MM-DD'))
      .pipe(
        map(
          (addressSuggestions) =>
            !Array.from(addressSuggestions.suggestions).some((address) => address.bfs_number === currentBfsNumber),
        ),
      );

    this.showZipCodeComponent$.pipe(untilDestroyed(this)).subscribe((value) => {
      if (value) {
        this.formGroup.get('bfsNumber')?.setValidators(Validators.required);
        this.formGroup.get('zipCode')?.setValidators(Validators.required);
        this.formGroup.get('city')?.setValidators(Validators.required);

        this.formGroup.get('bfsNumber')?.setValue(null);
        this.formGroup.get('zipCode')?.setValue(null);
        this.formGroup.get('city')?.setValue(null);

        this.formGroup.get('bfsNumber')?.enable();
        this.formGroup.get('zipCode')?.enable();
        this.formGroup.get('city')?.enable();
      }
    });

    this.address.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.formGroup.get('bfsNumber')?.setValue(value?.value.bfsNumber);
      this.formGroup.get('zipCode')?.setValue(value?.value.zipCode);
      this.formGroup.get('city')?.setValue(value?.value.city);
    });
  }
}
